import { ApiRequestError, isUnauthenticatedError } from "./api";

/*
 * One place decides how a client request failure reaches Sentry: 401 is a
 * sign-out, not a defect, so it is never captured; other 4xx are the server
 * refusing a request and rate as warnings; 5xx and transport failures are
 * errors. Consumers (QueryCache onError, the presence heartbeat) apply the
 * level and status tag without re-deriving them.
 */
export type ApiErrorCaptureDecision =
  | { capture: false; reason: "unauthenticated" }
  | { capture: true; level: "warning" | "error"; status: string };

export function decideApiErrorCapture(error: unknown): ApiErrorCaptureDecision {
  if (isUnauthenticatedError(error))
    return { capture: false, reason: "unauthenticated" };

  if (error instanceof ApiRequestError) {
    const level = error.status < 500 ? "warning" : "error";

    return { capture: true, level, status: String(error.status) };
  }

  return { capture: true, level: "error", status: "network" };
}
